import React from 'react';
import { BsPlus } from 'react-icons/bs';

import { useAppDispatch } from '../../../../app/hooks';
import { DriverPunchCardsTable } from '../DriverPunchCardsTable/DriverPunchCardsTable';
import { PunchCardsForAllDrivers, DriverPayPeriodSummary, getWorkTimeForDriver } from '../../../../models';
import { setShowCreatePunchCardModal } from '../../punchCardSlice';

import { ReactComponent as Close } from '../../../../assets/images/close.svg';
import './DriverPunchCardsCard.scss';

export interface DriverPunchCardsCardProps {
  summary: PunchCardsForAllDrivers;
  driverPayPeriodSummary?: DriverPayPeriodSummary;
  onClose: () => void;
}

export function DriverPunchCardsCard(props: DriverPunchCardsCardProps) {
  const dispatch = useAppDispatch();
  const { summary, driverPayPeriodSummary, onClose } = props;

  const onAddPunchCardClick = () => {
    dispatch(setShowCreatePunchCardModal({ driverId: summary.driver.id }));
  };

  const formatDecimalHours = (minutes: number) => `${(minutes / 60).toFixed(2)} hrs`;

  return (
    <div className='driver-punch-cards-card-component'>
      <div className='title-container'>
        <div className='left-container'>
          <div className='title'>{`${summary.driver.firstName} ${summary.driver.lastName}`}</div>
          <div className='subtitle-row'>
            <span className='subtitle'>{`Total: ${getWorkTimeForDriver(summary.summary)}`}</span>
            {driverPayPeriodSummary && (
              <>
                <span className='subtitle'>{`Regular: ${formatDecimalHours(driverPayPeriodSummary.totalRegularMinutes)}`}</span>
                <span className={`subtitle ${driverPayPeriodSummary.totalOvertimeMinutes > 0 ? 'overtime' : ''}`}>
                  {`Overtime: ${formatDecimalHours(driverPayPeriodSummary.totalOvertimeMinutes)}`}
                </span>
              </>
            )}
          </div>
        </div>

        <div className='right-container'>
          <div className='add-button' onClick={onAddPunchCardClick}>
            <BsPlus className='icon' />
            Add Punch Card
          </div>
          <Close className='close-button' onClick={onClose}/>
        </div>
      </div>

      <DriverPunchCardsTable summary={summary.summary}/>
    </div>
  );
}
